module.exports = __webpack_public_path__ + "images/fa-lf-bg-bottom-banner.webp";